
import { useState } from "react"
import {
  Box,
  Button,
} from "@mui/material"
import CreateOrder from "./CreateOrder"
import OrderHistory from "./OrderHistory"
import { userPermissions } from "../customerManagement/utility/authUtils"


export default function Order() {
  const [activeTab, setActiveTab] = useState("orders")

  const handleTabClick = (tabName) => {
    console.log("Switching to tab:", tabName)
    setActiveTab(tabName)
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case "orders":
        return <CreateOrder />
      case "orderHistory":
        return <OrderHistory />
      default:
        return <CreateOrder />
    }
  }

  const permissions = userPermissions()?.order;

  return (
    <Box>

      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: -8 }}>
          <Box sx={{ display: "flex", gap: 0 }}>

          
            {/* <Button
              onClick={() => handleTabClick("apiuser")}
              sx={{
                textTransform: "none",
                minHeight: 48,
                px: 3,
                fontSize: "1.1rem",
                fontWeight: 600,
                borderBottom: activeTab === "apiuser" ? 2 : 0,
                borderColor: "primary.main",
                borderRadius: 0,
                backgroundColor: activeTab === "apiuser" ? "rgba(25, 118, 210, 0.04)" : "transparent",
              }}
            >
              Api User
            </Button> */}
            {permissions.orders?.view && (
              <Button
              onClick={() => handleTabClick("orders")}
              sx={{
                textTransform: "none",
                minHeight: 48,
                px: 3,
                fontSize: "1.1rem",
                fontWeight: 600,
                borderBottom: activeTab === "orders" ? 2 : 0,
                borderColor: "var(--bg)",
                color: "var(--bg)",
                borderRadius: 0,
                backgroundColor: activeTab === "orders" ? "rgba(25, 118, 210, 0.04)" : "transparent",
              }}
            >
              Orders
            </Button>
            )}
            
            {permissions.orderHistory?.view && (
                          <Button
              onClick={() => handleTabClick("orderHistory")}
              sx={{
                textTransform: "none",
                minHeight: 48,
                px: 3,
                fontSize: "1.1rem",
                fontWeight: 600,
                borderBottom: activeTab === "orderHistory" ? 2 : 0,
                borderColor: "var(--bg)",
                color: "var(--bg)",
                borderRadius: 0,
                backgroundColor: activeTab === "orderHistory" ? "rgba(25, 118, 210, 0.04)" : "transparent",
              }}
            >
              Order History
            </Button>
            )}


          </Box>
        </Box>

        <Box sx={{ mt: 0 }}>{renderTabContent()}</Box>  
      </Box>
    </Box>
  )
}
